import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { LegalPage } from '@/features/legal/LegalPage';

/**
 * `/privacy` — the PUBLIC privacy policy (slice 81).
 *
 * The text is the English policy approved by Mahad (28 Sep 2026; the Raad Driver
 * section and edits approved 27 Oct 2026), stored under
 * `legal.privacy.*` in i18n. There is NO Somali policy yet, so in SO mode the
 * policy body stays English (identical value in so.json). The shared chrome
 * strings (back link, WhatsApp/email buttons) are ALSO English in so.json until
 * Mahad supplies Somali — an agent-written draft was removed (3b716672). Only
 * Mahad writes Somali; do not write a Somali policy or chrome here.
 */
const SECTION_KEYS = [
  'who',
  'process',
  'driver',
  'why',
  'whoElse',
  'howLong',
  'security',
  'choices',
  'contact',
] as const;

export function Privacy() {
  const { t } = useTranslation();

  return (
    <LegalPage title={t('legal.privacy.title')}>
      <p className="mt-4 font-display text-lg font-semibold">{t('legal.privacy.heading')}</p>
      <p className="mt-1 text-sm text-raad-muted">{t('legal.privacy.effective')}</p>

      <p className="mt-6 text-[15px] leading-relaxed text-raad-text">
        {t('legal.privacy.intro')}
      </p>

      <div className="mt-6 space-y-5">
        {SECTION_KEYS.map((key) => (
          <section key={key}>
            <h2 className="text-[15px] font-bold text-raad-text">
              {t(`legal.privacy.sections.${key}.h`)}
            </h2>
            <p className="mt-1 text-[15px] leading-relaxed text-raad-muted">
              {t(`legal.privacy.sections.${key}.p`)}
            </p>
          </section>
        ))}
      </div>

      <p className="mt-6 text-[15px] leading-relaxed">
        <Link
          to="/delete-account"
          className="font-semibold text-raad-primary underline underline-offset-2"
        >
          {t('legal.privacy.deletionLink')}
        </Link>
      </p>
    </LegalPage>
  );
}
